import axios from "axios";

const cleanParam = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text === "null" || text === "undefined") return "";
  return text;
};

export const downloadShipmentWeightReport = async (inputs = {}) => {
  const urlParams = new URLSearchParams();
  // const filterDateType = cleanParam(inputs.filter_date_type) || "order_date";
  const dateFrom = cleanParam(
    inputs.dispatch_est_delivery_date_from ||
      inputs.order_item_est_delivery_date_from ||
      inputs.date_from ||
      inputs.from
  );
  const dateTo = cleanParam(
    inputs.dispatch_est_delivery_date_to ||
      inputs.order_item_est_delivery_date_to ||
      inputs.date_to ||
      inputs.to
  );
  const month = cleanParam(inputs.month);
  const year = cleanParam(inputs.year);
  const portNoAndName = cleanParam(inputs.port_no_and_name);
  // const portNoFrom = cleanParam(inputs.port_no_from);
  // const portName = cleanParam(inputs.port_name);
  const transportType = cleanParam(inputs.transport_type);
  const salesmanId = cleanParam(
    inputs.salesman_id || inputs.sales_person?.id || inputs.sales_person_id
  );
  const salesmanName = cleanParam(
    inputs.salesman_name ||
      inputs.sales_person?.full_name ||
      inputs.sales_person
  );

  urlParams.set("filter_date_type", "dispatch_est_delivery_date");
  if (dateFrom) urlParams.set("dispatch_est_delivery_date_from", dateFrom);
  if (dateTo) urlParams.set("dispatch_est_delivery_date_to", dateTo);
  // if (dateFrom) urlParams.set("order_item_est_delivery_date_from", dateFrom);
  // if (dateTo) urlParams.set("order_item_est_delivery_date_to", dateTo);
  // if (dateFrom) urlParams.set("date_from", dateFrom);
  // if (dateTo) urlParams.set("date_to", dateTo);
  if (month) urlParams.set("month", month);
  if (year) urlParams.set("year", year);
  if (portNoAndName) urlParams.set("port_no_and_name", portNoAndName);
  // if (portNoFrom) urlParams.set("port_no_from", portNoFrom);
  // if (portName) urlParams.set("port_name", portName);
  if (transportType) urlParams.set("transport_type", transportType);
  if (salesmanId) urlParams.set("salesman_id", salesmanId);
  if (salesmanName) urlParams.set("salesman_name", salesmanName);

  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/dispatch/shipment-weight-report-excel?${urlParams.toString()}`,
      config
    );
    const result = data?.data?.result;
    if (typeof result === "string" && /^https?:\/\//i.test(result.trim())) {
      return result.trim();
    }
    return null;
  } catch (error) {
    console.log(error);
    if (error?.response?.data?.message) {
      throw error;
    }
    return null;
  }
};

export const downloadShopShipmentWeightReport = async (inputs = {}) => {
  const urlParams = new URLSearchParams();
  const dateFrom = cleanParam(
    inputs.dispatch_est_delivery_date_from ||
      inputs.shop_order_dispatch_est_delivery_date_from ||
      inputs.date_from ||
      inputs.from
  );
  const dateTo = cleanParam(
    inputs.dispatch_est_delivery_date_to ||
      inputs.shop_order_dispatch_est_delivery_date_to ||
      inputs.date_to ||
      inputs.to
  );
  const month = cleanParam(inputs.month);
  const year = cleanParam(inputs.year);
  const portNoAndName = cleanParam(inputs.port_no_and_name);
  const transportType = cleanParam(inputs.transport_type);
  const salesmanId = cleanParam(
    inputs.salesman_id || inputs.sales_person?.id || inputs.sales_person_id
  );
  const salesmanName = cleanParam(
    inputs.salesman_name ||
      inputs.sales_person?.full_name ||
      inputs.sales_person
  );

  urlParams.set("filter_date_type", "dispatch_est_delivery_date");
  if (dateFrom) urlParams.set("dispatch_est_delivery_date_from", dateFrom);
  if (dateTo) urlParams.set("dispatch_est_delivery_date_to", dateTo);
  if (month) urlParams.set("month", month);
  if (year) urlParams.set("year", year);
  if (portNoAndName) urlParams.set("port_no_and_name", portNoAndName);
  if (transportType) urlParams.set("transport_type", transportType);
  if (salesmanId) urlParams.set("salesman_id", salesmanId);
  if (salesmanName) urlParams.set("salesman_name", salesmanName);

  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/shop-order-dispatch/shipment-weight-report-excel?${urlParams.toString()}`,
      config
    );
    const result = data?.data?.result;
    if (typeof result === "string" && /^https?:\/\//i.test(result.trim())) {
      return result.trim();
    }
    return null;
  } catch (error) {
    console.log(error);
    if (error?.response?.data?.message) {
      throw error;
    }
    return null;
  }
};
